<template>
  <div class="message-list">
    <div class="page-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('message.list.notification') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <page-nav :items="pageItems" v-model="activePageNav"></page-nav>
    <keep-alive>
      <component :is="currentPage"></component>
    </keep-alive>
  </div>
</template>

<script>
import SubmitFailureMessage from './SubmitFailureMessage'
import UnpaidMoneyMessage from './UnpaidMoneyMessage'
import ComeVisaMessage from './ComeVisaMessage'
import RejectVisaMessage from './RejectVisaMessage'
export default {
  name: 'messageList',
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  watch: {
    '$route.query.type': {
      immediate: true,
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.activePageNav = val
        }
      },
    },
  },
  data() {
    return {
      activePageNav: 'SUBMITFAILURE',
    }
  },
  computed: {
    pageItems() {
      return [
        { label: this.$t('message.list.submitFailure'), key: 'SUBMITFAILURE' },
        { label: this.$t('message.list.unpaidMoney'), key: 'UNPAIDMONEY' },
        { label: this.$t('message.list.comeVisa'), key: 'COMEVISA' },
        { label: this.$t('message.list.rejectVisa'), key: 'REJECTVISA' },
      ]
    },
    currentPage() {
      let page = null
      switch (this.activePageNav) {
        case 'SUBMITFAILURE':
          page = SubmitFailureMessage
          break
        case 'UNPAIDMONEY':
          page = UnpaidMoneyMessage
          break
        case 'COMEVISA':
          page = ComeVisaMessage
          break
        case 'REJECTVISA':
          page = RejectVisaMessage
          break
      }
      return page
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/style/color.scss';
.message-list {
  margin: 10px 20px;
}
.message {
  &-empty {
    font-size: 16px;
    color: $color-black-38;
    text-align: center;
    padding: 16px 0;
  }
  &-item {
    padding: 15px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $color-border;
    &__info {
      color: $color-black-87;
      p {
        margin: 0;
      }
    }
    &__title {
      font-weight: 700;
      font-size: 16px;
      line-height: 26px;
      position: relative;
      &.new::before {
        content: '';
        position: absolute;
        left: -16px;
        top: 50%;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        background-color: $color-green-dark;
        border-radius: 50%;
      }
    }
    &__desc {
      font-size: 14px;
      line-height: 23px;
      padding-top: 8px;
    }
  }
  .page-section {
    padding-top: 0 !important;
  }
}
</style>
